export const orgSchemaProps = {
  name: "Swaminarayan Temple Karelibaug-Vadodara and Kundaldham",
  url: "https://www.swaminarayanbhagwan.org",
  logo: "https://s3.smk.org/random_media/organization-logo/kundal-logo.png",
  description: "A temple of Lord Swaminarayan (Swaminarayan Bhagwan) is a spiritual organization dedicated to betterment of society.",
  email: "info@swaminarayanbhagawan.org",
  telephone: "+91-9601290001",
  sameAs: [
    "https://www.facebook.com/swaminarayanbhagwan2/",
    "https://www.instagram.com/swaminarayanbhagwan_/",
    "https://x.com/Swaminarayanbh3",
    "https://www.youtube.com/swaminarayanbhagwan1",
    "https://www.youtube.com/Swaminarayan",
  ],
  address: {
    streetAddress: "Pani Tanki Rd, Karelibaug",
    addressLocality: "Vadodara",
    addressRegion: "GJ",
    postalCode: "390018",
    addressCountry: "IN",
  },
  foundingDate: "1990-01-01",
};
